<xux-widget-boilerplate [field]="field">
  <div class="checkbox-group" [ngClass]="field?.class">
    <div class="checkbox-item">
      <span>
        <input type="checkbox" [formControl]="field?.control" />
        {{ staticTextContent.checked | translate }}
      </span>
    </div>
  </div>
</xux-widget-boilerplate>
